const $ = jQuery;

export default {
    init() {
        setupHeaderScroll();
        setupDropdowns();
    }
};

function setupHeaderScroll() {
    const $header = $('#header');
    const $wpAdminBar = $('#wpadminbar');

    if (!$header.length) {
        return;
    }

    function updateHeaderTop() {
        const adminBarHeight = $wpAdminBar.length ? $wpAdminBar.outerHeight() : 0;
        $header.css('top', adminBarHeight + 'px');
        $wpAdminBar.css('position', 'fixed');
    }

    function updateHeaderState() {
        if ($(window).scrollTop() > 50) {
            $header.addClass('is-scrolled');
        } else {
            $header.removeClass('is-scrolled');
        }
    }

    updateHeaderTop();
    updateHeaderState();

    $(window).on('scroll', updateHeaderState);
    $(window).on('resize', updateHeaderTop);
}

function setupDropdowns() {
    const $menuItems = $('#menu-primary-navigation .menu-item-has-children, #menu-primary-navigation-ocm .menu-item-has-children');

    $menuItems.children('a').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const $parentLi = $(this).parent();
        const wasOpen = $parentLi.hasClass('is-open');

        $menuItems.removeClass('is-open');

        if (!wasOpen) {
            $parentLi.addClass('is-open');
        }
    });

    $(document).on('click', function(e) {
        if (!$(e.target).closest('.menu-item-has-children').length) {
            $menuItems.removeClass('is-open');
        }
    });
}
